import { getIdPortenToken, idPorten } from './authentication';
import { info, warn } from '../notify';
import { listUsers } from '../user';
import { moveTo } from '../wizard';

const updateList = () => getUsers().then(users => listUsers(users));

export const saveUserInfo = (email, isoDate, comment) => {
  const expiration = isoDate.split('-').reverse().join('.');
  console.log('Save user information:', email, expiration);
  const api = '/klimagasskalkulator_ws/admin/user';
  getIdPortenToken().then(token => {
    const request = new Request(api, {
      method: 'POST',
      body: JSON.stringify({ email, comment, validTil: expiration }),
      headers: new Headers({
        'Content-Type': 'application/json',
        nibiotoken: token
      })
    });
    idPorten(
      request,
      response => {
        info('En e-post med aktiverinkslenk ble sendt til brukeren');
        updateList();
      },
      response => document.getElementById('fError').hidden = false
      // response => console.log('onComplete')
      // undefined
    );
  }).catch(err => console.log('catch', err));
};

export const saveUserOwnInfo = (email) => {
  console.log('Save user own information:', email);
  const api = '/klimagasskalkulator_ws/user';
  getIdPortenToken().then(token => {
    const request = new Request(api, {
      method: 'PUT',
      body: JSON.stringify({ email }),
      headers: new Headers({
        'Content-Type': 'application/json',
        nibiotoken: token
      })
    });
    idPorten(
      request,
      response => info('E-post ble endret'),
      response => warn('E-post kunne ikke endres')
      // response => console.log('onComplete')
      // undefined
    );
  }).catch(err => console.log('catch', err));
};

export const getUsers = () => new Promise((resolve, reject) => {
  console.log('Get list of registered users');
  const api = '/klimagasskalkulator_ws/admin/user/groups';
  getIdPortenToken().then(token => {
    const request = new Request(api, {
      method: 'GET',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(
      request,
      (response) => resolve(response),
      (response) => reject(console.log('onError'))
      // (response) => console.log('onComplete')
      // undefined
    );
  }).catch(err => reject(console.log('catch', err)));
});

export const deleteUser = (id, itself) => new Promise((resolve, reject) => {
  console.log('Delete user', id);
  const ws = '/klimagasskalkulator_ws';
  const api = itself ? `${ws}/user` : `${ws}/admin/user/${id}`;
  getIdPortenToken().then(token => {
    const request = new Request(api, {
      method: 'DELETE',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(
      request,
      respon => {
        if (respon === '' || respon === true) resolve('Brukeren ble slettet');
        else reject('Brukeren kunne ikke slettes');
      },
      response => reject('Brukeren kunne ikke slettes')
      // response => console.log('onComplete')
      // undefined
    );
  }).catch(err => reject(console.log('catch', err)));
});

export const editUser = (id, iso, comment) => new Promise((resolve, reject) => {
  const exp = iso.split('-').reverse().join('.');
  console.log('Update user', id);
  const api = `/klimagasskalkulator_ws/admin/user/${id}`;
  getIdPortenToken().then(token => {
    const request = new Request(`${api}?valid=${exp}&comment=${comment}`, {
      method: 'PUT',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(
      request,
      response => resolve(response),
      response => reject(console.log('onError'))
      // response => console.log('onComplete')
      // undefined
    );
  }).catch(err => reject(console.log('catch', err)));
});

